import { render, staticRenderFns } from "./ToolAxisRectify.vue?vue&type=template&id=8b9f28d0&scoped=true"
import script from "./ToolAxisRectify.vue?vue&type=script&lang=js"
export * from "./ToolAxisRectify.vue?vue&type=script&lang=js"
import style0 from "./ToolAxisRectify.vue?vue&type=style&index=0&id=8b9f28d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9f28d0",
  null
  
)

export default component.exports